import React, { useState, useEffect, useContext } from 'react'

import { withStyles } from '@material-ui/core/styles'
import { Typography, Paper } from '@material-ui/core'
import Box from '@material-ui/core/Box'
import CheckCircleIcon from '@material-ui/icons/CheckCircle'

const styles = theme => ({
  root: {
  },
  sectionTrainingProgress:{
    padding: theme.spacing(3),
    background: 'white',
    width: '100%',
    flexDirection: 'row',
    display: 'flex',
    [theme.breakpoints.down('xs')]:{
        width: '100%',
        margin: 0
    }
  },
  checkDefault:{
    color: '#cecece',
    marginRight: theme.spacing(1),
    fontSize: '30px'
  },
  checkError:{
    color: 'red',
    fontSize: '30px'
  },
  checkDefaultActive:{
    color: 'rgb(40, 109, 204)',
    marginRight: theme.spacing(1),
    fontSize: '30px'
  },
  labelProgressActive:{
    fontWeight: 'bold'
  },
  mainDiv:{
    position: 'relative',
    marginLeft: -12,
    marginRight: -12
  },
  completedDiv:{
    position: 'absolute',
    top: '40%',
    margin: '0 auto',
    width: '100%',
    display: 'flex',
    alignItems: 'center', // does vertically center the desired content
    justifyContent: 'center', // horizontally centers single line items
    textAlign: 'center'
  },
  iconCheck: {
    fontSize: '48px'
  }
});

const StatusTracker = ({ classes, theme, activeStatus, listStatus }) => {
  const steps = listStatus;
  
  let rootStyle = {}

  // if(activeStatus === 3){
  //     rootStyle['opacity'] = "0.1"
  // }

  return (
    <>
      <div className={classes.mainDiv}>
        { activeStatus !== -1 ?
          <Paper className={classes.sectionTrainingProgress} style={rootStyle} elevation={0}>
            { steps.map((label,index) => (
            <Box style={{position:'relative'}} display='flex' flexDirection='column' flex={1} alignItems="center" mb={1}>
              { index !== 0 &&
              <Box style={{position:'absolute', top: 12, left: 'calc(-50% + 15px)', right: 'calc(50% + 25px)'}}>
                <Box style={{borderTopStyle: 'solid', borderTopWidth: index <= activeStatus ? 2 : 1, borderTopColor: index <= activeStatus ? '#1976d2' : 'lightgrey'}}>
                </Box>
              </Box>
              }

              <CheckCircleIcon className={index < activeStatus ? classes.checkDefaultActive : classes.checkDefault}/>
              
              { activeStatus !== index ?
                <Typography variant='body1' style={{color: index >= activeStatus ? '#999' : 'black'}}>{label}</Typography>
              :
                <Typography variant='body1' className={classes.labelProgressActive}>{label}</Typography>
              }
            </Box>
            ))}
          </Paper>
          :
          null
        }
      </div>
    </>
  )
}

export default withStyles(styles, { withTheme: true })(StatusTracker)